export const SET_INPUT = 'SET_INPUT';
export const SET_OUTPUT = 'SET_OUTPUT';
export const SET_QUESTION = 'SET_QUESTION';
export const SET_CHAT = 'SET_CHAT'